exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".company-observe[data-v-075c17f6]{box-sizing:border-box;padding:24px}.company-observe__header[data-v-075c17f6]{align-items:flex-end;display:flex;justify-content:space-between;margin-bottom:20px}.company-observe__header h2[data-v-075c17f6]{color:#333;font-size:20px;font-weight:400;margin:0 0 8px}.company-observe__header p[data-v-075c17f6]{color:#8492a6;font-size:13px;margin:0}.company-observe__search[data-v-075c17f6]{display:flex;gap:8px;width:430px}.company-observe__pagination[data-v-075c17f6]{margin-top:20px;text-align:right}.company-observe__unavailable[data-v-075c17f6]{color:#bfcbd9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-075c17f6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/companyObserve/companyObserve.vue
// module id = 588
// module chunks = 1